import { render, staticRenderFns } from "./EmptyNode.vue?vue&type=template&id=c70b12b0&scoped=true"
import script from "./EmptyNode.vue?vue&type=script&lang=js"
export * from "./EmptyNode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c70b12b0",
  null
  
)

export default component.exports